import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import SearchBar from './navbar-searchbar';
import { Envelope } from '../../common/icons';
import { checkPermission } from '../../common/guards/can';
import NavbarGoogleTranslate from './navbar-google-translate';

const NavbarTopLinks = (props) => {
  const { unreadMessages, gold, hasSelectTheme } = props;
  let envelopeIconClassName = 'nav-desktop-messages';

  if (gold) {
    envelopeIconClassName = 'nav-desktop-messages nav-desktop-messages-gold';
  }

  if (hasSelectTheme) {
    envelopeIconClassName = 'nav-desktop-messages nav-desktop-messages-select';
  }

  return (
    <div className="navbar-post-login">
      <SearchBar />
      <NavbarGoogleTranslate gold={gold} hasSelectTheme={hasSelectTheme} />
      {checkPermission('view', 'web_app_messages') && (
        <Link to='/my-messages'>
          <Envelope height={24} width={24} className={envelopeIconClassName} />
          <span className="nav-mobile-messages">Messages</span>
          <span className="nav-messages-count">{unreadMessages}</span>
        </Link>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  unreadMessages: state.messages.unreadMessagesCount
});

export default connect(mapStateToProps)(NavbarTopLinks);
